// extracted by mini-css-extract-plugin
module.exports = {"content":"notfound_content__-z-3g","text":"notfound_text__1WQgS","anim":"notfound_anim__2QJnl"};